import React from 'react';
import { CardMedia } from '@mui/material';
import Card from '@components/Atoms/Card';
import Box from '@components/Atoms/Box';
import Typography from '@components/Atoms/Typography';
import { useGetLessonDetail } from '@components/Component/Lesson/LessonContainer/hooks/query';
import { useGetUnitDetails } from '@components/Component/Lesson/LessonContainer/hooks';
import PracticeInfo from '@components/Component/OLP/tab/PracticeInfo';
import {
  actionCardBodyStyle,
  cardBaseStyle,
  mediaCardWrapperStyle,
  mediaCardStyle,
  practiceInfoWrapperStyle,
  typographyCustomStyle,
  buttonsWrapperBoxStyle,
} from './ActionCard.style';

import ResetActivityProvider from '@components/Component/OLP/tab/Provider/ResetActivityProvider';
import ShowIf from '@components/Atoms/ShowIf';
import { useInteractionContext } from '@components/ElementAnalytics/InteractionContext';


const imgUrl = '/images/group_activity.png';

type ActionCardProps = {
  /** Optional data test id */
  dataTestId?: string;
  /** Optional tip text to display at the top of the card */
  tipText?: string | undefined;
  /** Optional React component to show buttons  */
  actionButtons?: React.ReactNode;
  /** Optional React nodes for different OGA modes */
  modes?: React.ReactNode;
};
/** Card component for a practice session action */
const ActionCard = ({
  dataTestId = 'action-card',
  tipText = undefined,
  actionButtons,
  modes
}: ActionCardProps): JSX.Element => {
  const { data: LessonDetail } = useGetLessonDetail();
  const { name } = useGetUnitDetails();
  const { getTestId } = useInteractionContext();
  return (
    <Card sx={cardBaseStyle} data-testid={getTestId(dataTestId)}>
      <ResetActivityProvider>
        <Box sx={mediaCardWrapperStyle}>
          <CardMedia
            sx={mediaCardStyle}
            component="img"
            image={imgUrl}
            alt="group activity icon"
          />
        </Box>
        <Box sx={actionCardBodyStyle}>
          <Box sx={practiceInfoWrapperStyle}>
            <Box sx={{ pt: { xs: 2, sm: 0, md: 0 } }}>
              <Typography variant="subtitle1" data-testid="unit-subtitle">
                {name}
              </Typography>
              <Typography
                data-testid="lesson-title"
                variant="h3"
                sx={typographyCustomStyle}
              >
                {LessonDetail?.name}
              </Typography>
            </Box>
            <ShowIf If={modes !== undefined}>
              <Box>{modes}</Box>
            </ShowIf>
            <Box>
              <PracticeInfo />
            </Box>
          </Box>
          <ShowIf If={tipText !== undefined}>
            <Box sx={{ paddingInlineEnd: { xs: 2, sm: 8, md: 17 } }}>
              <Typography variant="subtitle1">{tipText}</Typography>
            </Box>
          </ShowIf>
          <ShowIf If={actionButtons !== undefined}>
            <Box sx={buttonsWrapperBoxStyle}>{actionButtons}</Box>
          </ShowIf>
        </Box>
      </ResetActivityProvider>
    </Card>
  );
};

export default ActionCard;
